<div class="dialog-header" [attr.dir]="rtlService.$isRTL.value ? 'rtl' : 'ltr'">
  <div class="header-icon">
    <mat-icon>widgets</mat-icon>
  </div>
  <h2>{{ "widgetInstructions.title" | translate: { brand: brand } }}</h2>
</div>

<mat-dialog-content cdkTrapFocus [attr.dir]="rtlService.$isRTL.value ? 'rtl' : 'ltr'">
  <p class="intro">{{ "widgetInstructions.intro" | translate: { brand: brand } }}</p>

  <ol class="steps">
    <li *ngFor="let n of steps">
      <span class="step-num">{{ n }}</span>
      <span class="step-text">{{ "widgetInstructions.step" + n | translate: { brand: brand } }}</span>
    </li>
  </ol>

  <p class="hint">{{ "widgetInstructions.hint" | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions [align]="rtlService.$isRTL.value ? 'start' : 'end'">
  <button mat-raised-button class="got-it-btn" cdkFocusInitial (click)="close()">
    {{ "widgetInstructions.gotIt" | translate }}
  </button>
</mat-dialog-actions>
